import axios from 'axios'
import {
  getToken
} from '@/utils/auth'

const service = axios.create({
	baseURL: process.env.VUE_APP_Server,
	timeout: 500000
});

// 添加请求拦截器
service.interceptors.request.use(function(config) {
	if (config.method.toUpperCase() == "POST") {
		var token=getToken();
		if (token) config.headers['tokenId'] = token.tokenId;
		config.headers['Content-Type'] = 'application/json; charset=utf-8'
		config.data = JSON.stringify(config.params);
	}
	return config;
}, function(error) {
	Notification({
		title: 'Error',
		message: '网络出现异常',
		showClose: true
	})
	Promise.reject(error)
});

// 添加响应拦截器
service.interceptors.response.use(function(response) {
	var json = response.data;
	var result = {
		"Code": json.code,
		"Msg": json.message,
		"Data": json.body
	}
	return result;
}, function(error) {
	error.message = '连接失败'
	return Promise.resolve(error.response)
});



export default service
